import http from '@/services/HttpService';
import { AxiosResponse } from 'axios';
import useSWR, { BareFetcher } from 'swr';

interface Props {
    revalidateOnMount?: boolean;
    refreshInterval?: number;
}

const defaultFetcher = (url: string) => http.get(url).then((response: AxiosResponse) => response.data);

/*
Exemplo de uso:
const { data: publicPerson } = useGet<Person>(`${Constants.PEOPLE_URI}/${person.id}?withoutPrivateData=true`);
*/
export const useGet = <T>(key: string | null, configuration?: Props, fetcher?: BareFetcher<T> | null) => {
    const { data, error, mutate, isValidating } = useSWR<T>(key, fetcher || defaultFetcher, {
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnMount: configuration?.revalidateOnMount,
        refreshInterval: configuration?.refreshInterval,
    });

    const isLoading: boolean = !data && !error;

    const revalidateResult = () => {
        mutate(data);
    };

    return {
        data,
        hasError: error,
        loading: isLoading,
        revalidateResult,
        isValidating,
        mutate,
    };
};
